import { useRouter } from 'next/navigation'
import { appendDebugTranslationsParam } from '../i18n/debug-translations'

export const useNavigate = () => {
  const router = useRouter()

  const push = (url: string) => {
    router.push(appendDebugTranslationsParam(url))
  }

  const replace = (url: string) => {
    router.replace(appendDebugTranslationsParam(url))
  }
  return { ...router, push, replace }
}
